import Component from '@bythepixel/component-loader';

export default class RippleClick extends Component {
  static selector = '[data-comp-ripple-click]';
  static loaderPriority = 'in-view';

  constructor(container, options = {}) {
    super(container, options);

    this.bindClickEvents();
  }

  bindClickEvents() {
    this.$container.addEventListener('mousedown', (event) => {
      const rect = this.$container.getBoundingClientRect();
      const buttonWidth = this.$container.offsetWidth;
      const clickX = event.clientX - rect.left;
      const clickY = event.clientY - rect.top;

      // remove any ripples that are hangin out still
      const oldRipples = this.$container.querySelectorAll('span.ripple');
      oldRipples.forEach((oldRipple) => {
        oldRipple.remove();
      });

      const startX = clickX - (buttonWidth / 2);
      const startY = clickY - (buttonWidth / 2);

      const ripple = document.createElement('span');
      ripple.classList.add('ripple');
      ripple.style.left = `${startX}px`;
      ripple.style.top = `${startY}px`;
      ripple.style.width = `${buttonWidth}px`;
      ripple.style.height = `${buttonWidth}px`;

      this.$container.appendChild(ripple);
    });
  }
}
